import { ToastContainer } from "react-toastify";
import "./App.css";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { StartExamPage } from "./page/start-exam";
import Header from "./components/header";
import { useState } from "react";
import AuthCm from "./components/auth-cm";
import ErrCm from "./components/err";
import LoginOtp from "./page/login-otp";
import Main from "./page/main";

import { DBConfig } from "./helper/env";
import { initDB } from "react-indexed-db-hook";

initDB(DBConfig);

function App() {
  const [auth, setAuth] = useState({
    data: {
      phone_number: "",
      full_name: "",
    },
    loading: true,
  });
  const [err, setErr] = useState(0);
  return (
    <>
      <ToastContainer rtl />
      <Header />
      {auth.loading ? (
        <AuthCm auth={auth} setErr={setErr} setAuth={setAuth} />
      ) : err ? (
        <ErrCm code={err} />
      ) : (
        <HashRouter>
          <Routes>
            <Route
              path={"/start/:id"}
              element={<StartExamPage {...auth.data} />}
            />
            <Route
              path={"/login-otp/:id"}
              element={<LoginOtp {...auth.data} />}
            />
            <Route path="/exam/:id" element={<Main />} />
            <Route path="*" element={<Navigate to={"/exam/0__0"} />} />
          </Routes>
        </HashRouter>
      )}
    </>
  );
}

export default App;